var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":require("@/assets/background.png"),"alt":"background image","eager":"","id":"image_background","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }